import wixWindow from 'wix-window';
// For full API documentation, including code examples, visit http://wix.to/94BuAAs
let currentImg=1;

function changePictures(){
	let nextImg = currentImg+1;
	if (nextImg>4) {nextImg=1;}
	
	$w("#Img"+nextImg).show("FadeIn");
	$w("#Img"+currentImg).hide("FadeOut");
	
	$w("#bg"+nextImg).show("FadeIn");
	$w("#bg"+currentImg).hide("FadeOut");

	currentImg = nextImg;
}

$w.onReady(function () {
	//TODO: write your page related code here...
	setTimeout(changePictures, 3000);
	setInterval(changePictures, 8000); 

//	setInterval(showScroll, 1000); 
});


function showScroll(){
wixWindow.getBoundingRect()
  .then( (windowSizeInfo) => {
    let windowHeight = windowSizeInfo.window.height;      // 565
    let windowWidth = windowSizeInfo.window.width;        // 1269
    let documentHeight = windowSizeInfo.document.height;  // 780
    let documentWidth = windowSizeInfo.document.width;    // 1269
    let scrollX = windowSizeInfo.scroll.x;                // 0
    let scrollY = windowSizeInfo.scroll.y;                // 120
		console.log(scrollY)
		if (scrollY > 1000)     { if ($w("#boxOrange").hidden) {$w("#boxOrange").show(); }}
	  else if (scrollY > 500) { if (!$w("#boxOrange").hidden){$w("#boxOrange").hide(); }}
		else if (scrollY >= 125) { if ($w("#boxOrange").hidden) {$w("#boxOrange").show(); }}
		else                    { if (!$w("#boxOrange").hidden){$w("#boxOrange").hide(); }}
  } );
}